import { useEffect, useRef } from 'react';

const useFlushWhenTabInactive = (isActive: boolean, flush: () => void) => {
  const wasActiveRef = useRef(isActive);

  useEffect(() => {
    if (wasActiveRef.current && !isActive) {
      flush();
    }
    wasActiveRef.current = isActive;
  }, [isActive, flush]);
};

export default useFlushWhenTabInactive;
